export default __webpack_public_path__ + "static/media/4-Ibrahim-Hvor føler du deg mest hjemme.6d09229b.mp4";